import { defineModule } from '@kubdee/sdk'
import { MODULES } from '@kubdee/shared'
import { migrations } from './migrations'
import { inventoryDoctypes } from './doctypes'

// 🔄 To change icon, also add the new icon to apps/web/src/lib/icon-registry.ts
const MODULE_ICON = 'Warehouse'
const MODULE_COLOR = '#2490EF'

export default defineModule({
  name: MODULES.INVENTORY,
  label: 'คลังสินค้า',
  icon: MODULE_ICON,
  color: MODULE_COLOR,
  version: '1.0.0',
  dependencies: [MODULES.CORE, MODULES.ACCOUNTING],
  category: 'operations',
  isSystemModule: false,

  schemas: {},
  routes: {},
  navigation: {
    label: 'คลังสินค้า',
    icon: MODULE_ICON,
    groups: [
      {
        label: 'ภาพรวม',
        items: [
          { label: 'แดชบอร์ด', path: '/inventory/dashboard', icon: 'LayoutDashboard' },
        ],
      },
      {
        label: 'ข้อมูลหลัก',
        items: [
          { label: 'คลังสินค้า', path: '/inventory/warehouses', icon: 'Warehouse' },
        ],
      },
      {
        label: 'ธุรกรรม',
        items: [
          { label: 'ใบรับสินค้า', path: '/inventory/goods-receipts', icon: 'PackagePlus' },
          { label: 'ใบส่งของ', path: '/inventory/delivery-orders', icon: 'PackageCheck' },
          { label: 'ใบโอนสินค้า', path: '/inventory/stock-transfers', icon: 'ArrowRightLeft' },
          { label: 'การเคลื่อนไหวสินค้า', path: '/inventory/stock-entries', icon: 'ArrowLeftRight' },
        ],
      },
      {
        label: 'รายงาน',
        items: [
          { label: 'สินค้าคงเหลือ', path: '/inventory/stock-ledger', icon: 'Package' },
          { label: 'ปิดงวดคลังสินค้า', path: '/inventory/period-close', icon: 'Shield' },
        ],
      },
    ],
  },
  permissions: {},
  hooks: {},

  doctypes: [
    { key: "warehouses", label: "คลังสินค้า" },
    { key: "stock-entries", label: "การเคลื่อนไหวสินค้า" },
    { key: "goods-receipts", label: "ใบรับสินค้า", type: "submittable", branchScope: { type: "single", fields: ["branchId"], createField: "branchId" } },
    { key: "delivery-orders", label: "ใบส่งของ", type: "submittable", branchScope: { type: "single", fields: ["branchId"], createField: "branchId" } },
    { key: "stock-transfers", label: "ใบโอนสินค้า", type: "submittable", branchScope: { type: "single", fields: ["branchId"], createField: "branchId" } },
  ],
  availableHooks: [
    { event: "inventory.goodsReceipt.submitted", label: "ยืนยันใบรับสินค้า" },
    { event: "inventory.deliveryOrder.submitted", label: "ยืนยันใบส่งของ" },
    { event: "inventory.stockTransfer.submitted", label: "ยืนยันใบโอนสินค้า" },
    { event: "inventory.stockEntry.created", label: "สร้างการเคลื่อนไหวสินค้า" },
    // Epic #443 — fired after sales-invoice / credit-note triggers cause
    // a stock deduction or return. Accounting subscribes to post / reverse
    // the COGS journal entry.
    { event: "inventory.invoice.stockDeducted", label: "ตัดสต็อกตามใบแจ้งหนี้" },
    { event: "inventory.invoice.stockReversed", label: "คืนสต็อกตามการยกเลิกใบแจ้งหนี้" },
    { event: "inventory.creditNote.stockReturned", label: "รับคืนสต็อกตามใบลดหนี้" },
  ],

  fixtures: [],

  moduleMigrations: migrations,

  // Doctype Admin Epic (#347, #423) — register inventory transactional doctypes
  // so the platform boot loop (`apps/tenant-worker/src/middleware/auto-migrate.ts`)
  // upserts `core_doctype_registry` rows + their `defaultSeries` into
  // `core_numbering_series` (company_id=NULL) on the first request per tenant.
  registeredDoctypes: inventoryDoctypes,
})
